import React from 'react';
import { connect } from 'react-redux'
import NuevaSolicitudAdministradora from './NuevaSolicitudAdministradora.jsx';

////Importación de actions.
import {
    getScreenData,
    routeTipoEmpresa,
    cancel,
    selectRadioButton,
    showError,
    routeToCancel,
    actualizarEstadoGlobal,
    resetState,
    routeToVistaCliente
} from '../actions/NuevaSolicitudAdministradoraActions.js';



const mapStateToProps = (state) => {
  
    return {
        data: {
            base: state.nuevaSolicitudAdministradora
        },
        tarjetas: state.tarjetas
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getScreenData: (currentScope) => {
            dispatch(getScreenData(currentScope));
        },
        routeTipoEmpresa: (administradora) => {
            dispatch(routeTipoEmpresa(administradora));
        },
        cancel: () => {
            dispatch(cancel());
        },
        selectRadioButton: (id, descripcion, codigo) => {
            dispatch(selectRadioButton(id, descripcion, codigo));
        },
        showError: () => {
            dispatch(showError());
        },
        routeToCancel: () => {
            dispatch(routeToCancel());
        },
        actualizarEstadoGlobal: () => {
            dispatch(routeToCancel());
        },
        resetState: () => {
            dispatch(resetState());
        },
        routeToVistaCliente: () => {
            dispatch(routeToVistaCliente());
        }
    }
}

//Connect entre el componente y las props y actions.
const NuevaSolicitudAdministradoraContainer = connect(mapStateToProps, mapDispatchToProps)(NuevaSolicitudAdministradora);

export default NuevaSolicitudAdministradoraContainer;
